import React from 'react';

const InvestmentPreferenceIcon = ({ colour = '#2F8FFF', width = '20', height = '20' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.75 3H15.75" stroke={colour} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.75 1V5" stroke={colour} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.75 3H0.75" stroke={colour} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M4.75 10H0.75" stroke={colour} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M8.75 8V12" stroke={colour} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M19.75 10H8.75" stroke={colour} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.75 17H15.75" stroke={colour} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.75 15V19" stroke={colour} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M11.75 17H0.75" stroke={colour} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default InvestmentPreferenceIcon;
